<template>
    <div class="container-custom"><slot></slot></div>
</template>

<script setup lang="ts"></script>

<style lang="less">
    .container-custom {
        min-width: @size-mobile-bottom;
        max-width: @container-width;
        width: 100%;
        margin: 0 auto;

        @media (max-width: @size-desktop-top) {
            max-width: 100%;
            padding-left: @container-padding;
            padding-right: @container-padding;
        }

        @media (max-width: @size-mobile-top) {
            padding-left: @container-padding-mobile;
            padding-right: @container-padding-mobile;
        }
    }
</style>
